import { useState } from "react";

export default function usePlannerPanels() {
  const [overflowPanel, setOverflowPanel] = useState(null);
  const [overflowTitle, setOverflowTitle] = useState("");
  const [completedPanelOpen, setCompletedPanelOpen] = useState(false);
  const [pastPanelOpen, setPastPanelOpen] = useState(false);
  const [calendarExpanded, setCalendarExpanded] = useState(false);
  const [expandedWorkerUid, setExpandedWorkerUid] = useState(null);

  return {
    overflowPanel,
    setOverflowPanel,
    overflowTitle,
    setOverflowTitle,
    completedPanelOpen,
    setCompletedPanelOpen,
    pastPanelOpen,
    setPastPanelOpen,
    calendarExpanded,
    setCalendarExpanded,
    expandedWorkerUid,
    setExpandedWorkerUid,
  };
}